import { styled } from '@mui/material'

export const Root = styled('div')`
  text-align: center;
`
